import { z } from "zod";

const text = z
  .string()
  .nullish()
  .transform((value) => value ?? "");

const contactPreviewPhoneSchema = z.object({
  place: text,
  number: text,
});

const contactPreviewEmailSchema = z.object({
  place: text,
  address: text,
});

const contactPreviewUrlSchema = z.object({
  place: text,
  url: text,
});

const contactPreviewAddressSchema = z.object({
  place: text,
  street: text,
  extendedAddress: text,
  postOfficeBox: text,
  postalCode: text,
  city: text,
  state: text,
  country: text,
});

export const contactPreviewSchema = z.object({
  id: z.number(),
  displayName: text,
  organization: text,
  isOrganization: z
    .boolean()
    .nullish()
    .transform((value) => value ?? false),
  hasPhoto: z
    .boolean()
    .nullish()
    .transform((value) => value ?? false),
  avatarUrl: text,
  phones: z.array(contactPreviewPhoneSchema).default([]),
  emails: z.array(contactPreviewEmailSchema).default([]),
  urls: z.array(contactPreviewUrlSchema).default([]),
  typedAddresses: z.array(contactPreviewAddressSchema).default([]),
});

export type ContactPreviewData = z.infer<typeof contactPreviewSchema>;

export type ContactPreviewAddress = z.infer<typeof contactPreviewAddressSchema>;
